import Emitter from "./Emitter";
import EmitterUtils from "../EmitterUtils";

export default class GameLoadProgress extends Emitter {

    static lastExecutionDate;

    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler(data) {
        if (data.payload && data.payload.progress && data.payload.progress === 1) {
            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderEnd"}), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderEnd"}), "*");
            }
        } else if (data.payload && data.payload.progress && data.payload.progress < 1) {
            const dataForXc = {
                "msgId":"rg2xcPreloaderProgress",
                "percentage": data.payload.progress,
                "localizedText":"loading assets..."
            }
            // this.emitParent(JSON.stringify(dataForXc))

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        }
    }

    LNWOGS_handler(data) {
        this.gb.wallet.updateProgress(data.payload.progress);
    }

    PLAYTECH_handler(data) {
        if (data && data.payload && data.payload.progress && data.payload.progress <= 1 && this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
            let dataForW = {_type: "ucip.loadingstatus.g2wLoadingProgressNotification", progress: parseInt(data.payload.progress*100)}
            this.emitParent(dataForW);
        }
    }

    SOFTSWISS_handler(data) {
        if (data && data.payload && data.payload.progress) {
            let datetimeNow = new Date();
            // Limit requests to 1 per 200 ms. Always post the first and last message.
            if (GameLoadProgress.lastExecutionDate === undefined || data.payload.progress === 1
                || datetimeNow.getTime() > EmitterUtils.addToDate(GameLoadProgress.lastExecutionDate, EmitterUtils.TimeUnits.MILLISECONDS, 200).getTime()) {
                this.emitParent({type: "a8r:v1:gtp:game_load_progress", payload:{percent: parseInt(data.payload.progress * 100)}});
                GameLoadProgress.lastExecutionDate = datetimeNow;
            }
        }
    }

    _default(msg) {

        const data = msg ? { wpgaction: "loadProgress", param: msg } : { wpgaction: "loadProgress" };
        const dataParent = msg ? { wpgaction: "loadProgress.parent", param: msg } : { wpgaction: "loadProgress.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
